



































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { EUserStatus, IChain, IFacility, IManagementUsersFiltersDTO, IUser, getIdFromEntityField, isObj } from '@zunta/configurations'
import { getModule } from 'vuex-module-decorators'
import { UserModule } from '@/store/modules/user.module'
import { ETableColumnType, ITableConfig } from '@/interfaces'
import Card from '@/components/Card.vue'
import Icon from '@/components/Icon.vue'
import { FacilityModule } from '@/store/modules/facility.module'
import Table from '@/components/tables/Table.vue'
import StatusUser from '@/components/statuses/StatusUser.vue'
import { downloadFile } from '@/utils/fileHelper'
import ButtonDownloadReport from '@/components/ButtonDownloadReport.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import SelectV2 from '@/components/inputsV2/SelectV2.vue'
import { getTooltipListText } from '@/utils/helpers'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import { PHONE_MASK } from '@/constants'

@Component({
  name: 'AdminUsers',
  components: {
    InputV2,
    SelectV2,
    ButtonDownloadReport,
    DateTimeLabel,
    Card,
    Icon,
    Table,
    StatusUser
  }
})
export default class FacilitiesUsers extends Vue {
  EUserStatus = EUserStatus
  selectedUser: IUser | null = null
  isLoading: boolean = true
  filters: any = {
    skip: 0,
    limit: 20,
    status: EUserStatus.ACTIVE
  }

  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  PHONE_MASK: any = PHONE_MASK

  getTooltipListText: Function = getTooltipListText

  config: ITableConfig = {
    useQuery: true,
    usePagination: true,
    rowClick: this.goFacilityUser,
    fetchFunction: this.fetchUserList,
    clearFilterBtn: {
      wrapperClass: 'position-absolute',
      wrapperStyle: 'top: calc(-1rem - 1px); right: -1.5rem;',
      class: 'rounded-bottom'
    },
    columns: [
      {
        minWidth: '150px',
        width: 10,
        key: 'chainName',
        searchKey: 'chainName',
        hasSearch: true,
        hasSort: true,
        label: 'Chain',
        type: ETableColumnType.default
      },
      {
        class: '',
        minWidth: '200px',
        width: 10,
        key: 'name',
        searchKey: 'name',
        hasSearch: true,
        hasSort: true,
        label: 'Name',
        type: ETableColumnType.default
      },
      {
        minWidth: '200px',
        width: 10,
        key: 'email',
        searchKey: 'email',
        hasSearch: true,
        hasSort: true,
        label: 'Email address',
        type: ETableColumnType.default
      },
      {
        minWidth: '200px',
        width: 13,
        key: 'phone',
        searchKey: 'phone',
        hasSearch: true,
        hasSort: true,
        label: 'Phone',
        type: ETableColumnType.default
      },
      {
        minWidth: '200px',
        width: 10,
        key: 'adminUser',
        searchKey: 'adminUser',
        hasSearch: true,
        hasSort: true,
        label: 'Zunta Rep',
        type: ETableColumnType.default
      },
      {
        minWidth: '150px',
        width: 9,
        searchKey: 'facilityId',
        hasSearch: true,
        hasSort: true,
        key: 'facilityId',
        label: 'Facilities',
        type: ETableColumnType.select,
        options: this.getFacilityItems
      },
      {
        class: '',
        minWidth: '100px',
        width: 10,
        searchKey: 'status',
        hasSearch: true,
        hasSort: true,
        key: 'status',
        label: 'Status',
        type: ETableColumnType.select,
        options: [
          {
            key: EUserStatus.ACTIVE,
            value: EUserStatus.ACTIVE,
            content: 'Active'
          },
          {
            key: EUserStatus.NOT_ACTIVE,
            value: EUserStatus.NOT_ACTIVE,
            content: 'Deactivated'
          }
        ]
      },
      {
        minWidth: '120px',
        width: 12,
        key: 'lastLogin',
        searchKey: 'lastLogin',
        hasSort: true,
        hasSearch: true,
        label: 'Last Login',
        type: ETableColumnType.dateRange
      },
      {
        class: '',
        minWidth: '100px',
        width: 8,
        key: 'role',
        searchKey: 'role',
        label: 'User Role',
        hasSort: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '120px',
        width: 8,
        key: 'taskStatus',
        searchKey: 'taskStatus',
        label: 'Task Status',
        hasSort: true,
        type: ETableColumnType.default
      }
    ]
  }

  get facilities () {
    return this.$store.state.facility.facilities.map((f: IFacility) => {
      return {
        id: f.id,
        name: f.name,
        chain: {
          id: f.chain ? getIdFromEntityField(f.chain) : NaN,
          name: isObj<IChain>(f.chain) ? f.chain.name : 'No Chain'
        }
      }
    })
  }

  get userList () {
    return this.$store.state.user.users
  }

  get userTotal () {
    return this.$store.state.user.total
  }

  get query () {
    return { ...this.$route.query, limit: '', skip: '', withTaskStatus: 'true' }
  }

  getUserStatusLabel (status: EUserStatus) {
    const map: any = {
      [EUserStatus.ACTIVE]: 'Active',
      [EUserStatus.NOT_ACTIVE]: 'Deactivated'
    }
    return map[status]
  }

  getFacilityItems () {
    return this.facilities.map((facility: IFacility) => {
      return {
        key: facility.id,
        value: `${facility.id}`,
        content: facility.name + '' + (facility.chain as IChain).name || '',
        facility: facility.name,
        chain: (facility.chain as IChain).name || ''
      }
    })
  }

  async mounted () {
    await this.facilityModuleInstance.getFacilityList({})
  }

  async fetchUserList (filters: Partial<IManagementUsersFiltersDTO>) {
    const query: IManagementUsersFiltersDTO = {
      ...filters,
      withTaskStatus: true
    }
    await this.userModuleInstance.getManagementUsersList(query)
  }

  goFacilityUser (item: any) {
    this.$locationManager.rememberAndGoTo({ name: 'admin-facilities-users-page', params: { id: item.id.toString() } })
  }

  getUserFacilities (user: IUser): string[] {
    if (user.isAllFacilities) {
      return this.facilities.filter(
        (facility: IFacility) => facility.chain && (facility.chain as IChain).id === ((user as IUser).chain as IChain).id
      )
    }

    if (!user.facilities || !user.facilities.length) {
      return []
    }

    return user.facilities.map((facilityId: string | number) => {
      return this.facilities.find((facility: IFacility) => facility.id === Number(facilityId))
    })
  }
}

